import { render, staticRenderFns } from "./ZadiOutlit.vue?vue&type=template&id=ed70a536&"
import script from "./ZadiOutlit.vue?vue&type=script&lang=js&"
export * from "./ZadiOutlit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports